module.exports = __webpack_public_path__ + "static/media/18ECA10.32d23a1c.jpg";